export default "__VITE_ASSET__CcDljwzX__"